import { db } from '$lib/firebase';
import { triggerModal } from '$lib/stores/modalStore';
import { updateDoc, doc, getDoc, setDoc, type DocumentData } from "firebase/firestore";
import { convertNumberTime, showOpTime } from './shop';

let CACHE_CATEGORIES: { [key: string]: Categories } = {};

export function invalidateCategoriesCache() {
    CACHE_CATEGORIES = {};
}

export function convertHours(hourIncomplete: HoursIncomplete = {}): HoursIncomplete {
    const hour: HoursIncomplete = {
        0: hourIncomplete[0] ?? [0, 24],
        1: hourIncomplete[1] ?? [0, 24],
        2: hourIncomplete[2] ?? [0, 24],
        3: hourIncomplete[3] ?? [0, 24],
        4: hourIncomplete[4] ?? [0, 24],
        5: hourIncomplete[5] ?? [0, 24],
        6: hourIncomplete[6] ?? [0, 24],
    }

    return hour;
}

export function generateCategory(): Category {
    const category:Category = {
        name: "",
        hours: convertHours(),
        defaultOptions: {},
        sharedOptions: []
    }

    return category;
}

export function isAvailable(hours: HoursIncomplete): boolean {
    const date = new Date();
    const day = date.getDay();
    const currentHour = date.getHours();
    const currentMinute = date.getMinutes();
    const currentTime = currentHour + currentMinute / 60;

    if (hours[day] === undefined || hours[day].length === 0) {
        return true; // If no hours are set for the day, assume it's available
    }

    for (let i = 0; i < hours[day].length; i += 2) {
        const openTime = hours[day][i];
        const closeTime = hours[day][i + 1];

        if (currentTime >= openTime && currentTime < closeTime) {
            // Check if the current minute is on a 15-minute interval
            if (currentMinute % 15 === 0) {
                return true;
            }
            
            // If not exactly on a 15-minute interval, check if we're within the last 15-minute window
            const lastInterval = Math.floor(currentTime * 4) / 4;
            if (lastInterval >= openTime && lastInterval < closeTime) {
                return true;
            }
        }
    }

    return false;
}

export function showTimes(category: Category) {
    let times = "";

    for (let day=0; day<7; day++) {
        const hoursArray = category.hours[day];
        times += numToDay(day.toString()) + ": ";

        let line = '<span style="float: right; margin-right: 10%;">';
        // let line = "";    

        for(let i = 0; i < hoursArray.length; i++)
        {
            if(i % 2 != 0)
            {
                line += showOpTime(convertNumberTime(hoursArray[i-1])) + " to ";
                line += showOpTime(convertNumberTime(hoursArray[i]));
                line += ", ";
            }
        }

        line += '</span>';
        // console.log(line)
        times += (line + "<br/>");
    }

    // console.log(times);

    triggerModal({
        title: category.name + " is available: ",
        body: times,
    })
}

function convertCategory(doc: DocumentData): Categories {
    const categories: Categories = [];

    if (typeof doc.categories !== "undefined") {
        for (const category of doc.categories) {
            let dataCategory: Category = {
                name: category.name ?? "",
                hours: convertHours(category.hours) ?? convertHours(),
                defaultOptions: category.defaultOptions ?? {},
                sharedOptions: category.sharedOptions ?? [],
            };

            dataCategory.hours = convertHours(dataCategory.hours);
            categories.push(dataCategory);
        }
    }

    return categories;
}

// gets all categories, if none exists, create empty array
export async function getCategories(shopID: string): Promise<Categories> {
    if (typeof CACHE_CATEGORIES[shopID] !== "undefined") {
        return CACHE_CATEGORIES[shopID];
    }

    let categories:Categories = [];

    try {
        const docRef = doc(db, "shops", shopID, "categories", "categories");
        const docSnap = await getDoc(docRef);
    
        const dataObj = docSnap.data();

        // if categories is not created
        if (!docSnap.exists || typeof dataObj?.categories === "undefined") {
            await setDoc((docRef), {
                categories: [],
            });
        }

        categories = convertCategory(dataObj ?? []);
        // console.log(categories);
    } catch (e) {
        console.log(e);
    }

    CACHE_CATEGORIES[shopID] = categories;
    return categories;    
}

// adds new category to list of categories
export async function addCategory(shop: string, newCategory: Category): Promise<void> {
    try {
        const docRef = doc(db, "shops", shop, "categories", "categories");
        const categories = await getCategories(shop);

        newCategory.hours = convertHours(newCategory.hours);
    
        categories.push(newCategory);
        
        await updateDoc(docRef, {
            categories: categories
        });
    } catch (e) {
        console.log(e);
    }
    
}

// updates list of categories
export async function updateCategories(shop:string, newCatList: Categories): Promise<void> {
    try {
        // console.log(newCatList);
        const docRef = doc(db, "shops", shop, "categories", "categories");

        await setDoc(docRef, {
            categories: newCatList,
        });

    } catch (e) {
        console.log(e);
    }
    
}

export function indexCategory(categories: Categories, index: number): Category {
    return categories[index] ?? generateCategory();
}


export function generateHours(): Hours {
    const hours: Hours = {
        0: [0, 24],
        1: [0, 24],
        2: [0, 24],
        3: [0, 24],
        4: [0, 24],
        5: [0, 24],
        6: [0, 24],
    }

    return hours;
}


export function numToDay(num: string):string {
    switch (num) {
        case '0':
            return "Sunday"
        case '1':
            return "Monday"
        case '2':
            return "Tuesday"
        case '3':
            return "Wednesday"
        case '4':
            return "Thursday"
        case '5':
            return "Friday"
        case '6':
            return "Saturday"
        default:
            return "Invalid Day"
    }
}